(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    // Language selector with flags - using event delegation
  document.addEventListener('click', function(e) {
    // Handle trigger click
    const trigger = e.target.closest('[data-language-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      
      const selector = trigger.closest('[data-language-selector]');
      const dropdown = selector ? selector.querySelector('[data-language-dropdown]') : null;
      
      if (dropdown) {
        const isOpen = !dropdown.hasAttribute('hidden');
        
        // Close all other dropdowns first
        document.querySelectorAll('[data-language-dropdown]').forEach(function(d) {
          d.setAttribute('hidden', '');
          const t = d.closest('[data-language-selector]').querySelector('[data-language-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        
        // Toggle this one
        if (!isOpen) {
          dropdown.removeAttribute('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        }
      }
      return;
    }
    
    // Handle option click
    const option = e.target.closest('[data-language-option]');
    if (option) {
      e.preventDefault();
      e.stopPropagation();
      
      const langCode = option.getAttribute('data-language-option');
      const selector = option.closest('[data-language-selector]');
      const form = selector ? selector.closest('form') : null;
      const hiddenSelect = form ? form.querySelector('select[name="language_code"]') : null;
      
      if (hiddenSelect && form) {
        hiddenSelect.value = langCode;
        form.submit();
      }
      return;
    }
    
    // Close all dropdowns when clicking outside
    if (!e.target.closest('[data-language-selector]')) {
      document.querySelectorAll('[data-language-dropdown]').forEach(function(dropdown) {
        dropdown.setAttribute('hidden', '');
      });
      document.querySelectorAll('[data-language-trigger]').forEach(function(trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
